import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useCreateSharedDeviceAuthRequestMutation } from "./__generated__/useCreateSharedDeviceAuthRequestMutation.graphql";

export function useCreateSharedDeviceAuthRequest(storeId?: string) {
  const [createAuthRequest, isCreatingAuthRequest] =
    useMutation<useCreateSharedDeviceAuthRequestMutation>(graphql`
      mutation useCreateSharedDeviceAuthRequestMutation($storeId: ID) {
        store(id: $storeId) {
          createSharedMobileDeviceAuthRequest {
            deviceCode
            expiresAtDate {
              isoString
            }
          }
        }
      }
    `);

  const createAuth = useCallback(() => {
    return new Promise<{ deviceCode: string; expiresAt: string }>(
      (resolve, reject) => {
        createAuthRequest({
          variables: { storeId: storeId },
          onCompleted: (data) => {
            const response = data.store.createSharedMobileDeviceAuthRequest;
            if (response) {
              resolve({
                deviceCode: response.deviceCode,
                expiresAt: response.expiresAtDate.isoString,
              });
            } else {
              reject(
                new Error(
                  "No response from createSharedMobileDeviceAuthRequest"
                )
              );
            }
          },
          onError: (error) => {
            reject(error);
          },
        });
      }
    );
  }, [createAuthRequest, storeId]);

  return [createAuth, isCreatingAuthRequest] as const;
}
